import {ANNOUNCEMENT_ID} from "./announcementConstants";

const getStorageKey = userId => `customerAnnouncementSeen:${ANNOUNCEMENT_ID}:${userId}`;

export const hasSeenAnnouncement = userId => {
    try {
        return localStorage.getItem(getStorageKey(userId)) === "true";
    } catch (e) {
        return false;
    }
};

export const markAnnouncementSeen = userId => {
    try {
        localStorage.setItem(getStorageKey(userId), "true");
    } catch (e) {
        // storage kapalı/dolu olabilir, sessizce geç
    }
};
